import { CalendarDays, Home, Handshake, LineChart, CheckCircle, type LucideIcon } from "lucide-react";

type ServiceCard = {
  title: string;
  icon: LucideIcon;
  items: string[];
};

const cards: ServiceCard[] = [
  {
    title: "Gestión de reservas",
    icon: CalendarDays,
    items: [
      "Manejo de anuncios",
      "Marketing y publicidad",
      "Gestión de reservas",
      "Atención al cliente en línea",
    ],
  },
  {
    title: "Cuidado del hogar",
    icon: Home,
    items: ["Limpieza", "Mantenimiento", "Mejoras al hogar", "Pagos mensuales"],
  },
  {
    title: "Hospitalidad 5 estrellas",
    icon: Handshake,
    items: [
      "Atención a huéspedes",
      "Servicio de concierge",
      "Experiencias locales",
      "Manejo de reseñas",
    ],
  },
  {
    title: "Obtén más ingresos",
    icon: LineChart,
    items: [
      "Análisis de datos",
      "Tarifas dinámicas",
      "Predicción de tendencias",
      "Reportes transparentes",
    ],
  },
];

const PropertyManagmentExtraServices = () => (
  <section className="py-16 bg-white mt-12 md:mt-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map(({ title, icon: Icon, items }) => (
          <article
            key={title}
            className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow border border-gray-200"
          >
            {/* Header with floating icon */}
            <div className="relative px-6 pt-6 pb-12 bg-gray-50">
              <div className="absolute top-4 left-4 w-12 h-12 rounded-full bg-brand-primary/10 border border-brand-primary/20 flex items-center justify-center">
                <Icon className="w-6 h-6 text-brand-primary" />
              </div>
            </div>

            {/* Content */}
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{title}</h3>
              <ul className="space-y-3">
                {items.map((item) => (
                  <li key={item} className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-brand-primary mr-3 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-800">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default PropertyManagmentExtraServices;
